<ion-header><app-navheader></app-navheader></ion-header>
<ion-content class="ion-no-padding">
  <ion-card *ngFor="let content of pageContent">
        <div [ngClass]= "{'article-detail-category-title-container': true, 'mquo': newspaperSubname === 'mquo',
         'lepq': newspaperSubname === 'lepq', 'actu': newspaperSubname === 'actu', 'aeco': newspaperSubname === 'aeco',
          'mlwk': newspaperSubname === 'mlwk', 'week': newspaperSubname === 'week', 'mwne': newspaperSubname === 'mwne',
          'woch': newspaperSubname === 'woch', 'mlne': newspaperSubname === 'mlne',
           'sema': newspaperSubname === 'sema', 'agregator': newspaperSubname === 'playbacpresse',
            'mwjp': newspaperSubname === 'mwjp', 'clfy': newspaperSubname === 'clfy',
             'mwde': newspaperSubname === 'mwde', 'mljp': newspaperSubname === 'mljp',
              'mlde': newspaperSubname === 'mlde'}">
          <h1>
            {{content.page_title}}
          </h1>
        </div>
        <div class="content" [innerHTML]="content.page_html | safeHtml"></div>
  </ion-card>
</ion-content>
<ion-footer>
	<app-bottom-menu [isActive] = "isActivePage" (bottomNotify) = "onBottomMenuNotify($event)"></app-bottom-menu>
</ion-footer>
<app-pop-up [show] = "tempPopUp" [data] = "popup" (popUpNotify)="onNotifyPopUp($event)" #temppopup></app-pop-up>
